<template>
  <layout>
    <div id="show-vacancy">
      <!-- Header -->
      <header
        :class="headerClasses()"
        :style="{
          'background-image': `url(${getHeaderImage})`,
          'background-color': `${getPrimaryColor}`
        }"
      >
        <!-- filter-header -->
        <div
          :class="`${currentScopedCompany.id == 2728 ? '' : 'overlay opacity-35'}`"
          style="background-image: linear-gradient(to top, #000000 0%, #000000 100%);"
        />
        <div class="container text-center">
          <div class="row">
            <div class="col-md-8 mx-auto pt-12 pb-9" />
          </div>

          <div class="partner partner-sm">
            <div
              id="global-info-vacancy"
              :class="`${infoClasses()}`"
            >
              <!-- START: SKELETON LOADING -->
              <div
                v-if="!hasInfoVacancy('company')"
                class="skeleton-loading"
              >
                <div
                  class="text-skeleton my-2 w-25 mx-auto d-block"
                  style="height: 16px"
                />
                <div
                  class="text-skeleton my-4 w-50 mx-auto d-block"
                  style="height: 40px"
                />
                <div
                  class="text-skeleton my-2 w-25 mx-auto d-block"
                  style="height: 16px"
                />
              </div>
              <!-- START: SKELETON LOADING -->
              <div v-if="hasInfoVacancy('company')">
                <p class="small text-center text-primary m-0 text-dark">
                  Vaga oferecida por
                  <strong>{{ setVacancyOwner(vacancy) }}</strong>
                </p>
                <h1
                  class="text-center font-weight-bold m-0"
                  :style="{'color': `${getPrimaryColor} !important`}"
                >
                  #{{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].id }} - {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.title }}
                </h1>
                <p
                  class="small text-center"
                  :style="{'color': `${getSecondaryColor} !important`}"
                >
                  <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.hibrida == true">
                    <i
                      class="fas fa-laptop"
                      aria-hidden="true"
                    /> Híbrido |
                  </span>
                  <span v-else-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.remoto == true">
                    <i
                      class="fas fa-laptop"
                      aria-hidden="true"
                    /> 100% remoto |
                  </span>
                  <span v-else-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.presencial == true">
                    <i
                      class="fas fa-building"
                      aria-hidden="true"
                    /> Presencial |
                  </span>
                  <i
                    class="fa fa-map-marker"
                    aria-hidden="true"
                  /> {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.location }} |
                  <i
                    class="fa fa-handshake-o"
                    aria-hidden="true"
                  />
                  <template v-if="!_.isObject(vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.contractingRegime)">
                    {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.contractingRegime }} |
                  </template>
                  <template v-else>
                    Não informado |
                  </template>
                  <i
                    class="fa fa-money"
                    aria-hidden="true"
                  /> {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.salary}}
                  <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.exclusivePcd == true"> |
                    <i
                      class="fa fa-wheelchair-alt"
                      aria-hidden="true"
                    /> Vaga exclusiva para PCD
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </header><!-- /.header -->

      <!-- Main Content -->
      <main class="main-content">
        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | About Vacancy
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <section
          id="about-vacancy"
          class="section pt-8 pb-8"
        >
          <div class="container">
            <!-- card What will you do -->
            <div class="card my-5">
              <div
                class="card-header"
                :style="{'background-color': `${getSecondaryColor} !important`}"
              >
                Sobre a vaga:
              </div>
              <div class="card-body card-description">
                <p
                  v-if="hasInfoVacancy('company')"
                  v-html="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.description"
                />
              </div>
            </div>

            <!-- card description vacancy -->
            <div class="card my-5">
              <div
                class="card-header"
                :style="{'background-color': `${getSecondaryColor} !important`}"
              >
                Descrição da oportunidade:
              </div>
              <div class="card-body">
                <table
                  v-if="hasInfoVacancy('company')"
                  class="table table-borderless"
                >
                  <tbody>
                    <!-- Área da vaga -->
                    <tr v-if="vacancy.areaOfInterest != undefined">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Área da vaga:
                      </th>
                      <td>
                        <strong>
                          {{ Object.values(vacancy.areaOfInterest).map((area_of_interest) => area_of_interest.attributes.name).join(', ') }}
                        </strong>
                        <span v-if="vacancy.experienceTag != undefined">
                          <span
                            v-for="(experience, index) in Object.values(vacancy.experienceTag)"
                            :key="index"
                          >
                            {{ (experience.attributes.tags.length > 0) ? ':' : '' }}
                            {{ experience.attributes.tags.map((tag) => tag).join(', ') }}
                          </span>
                        </span>
                      </td>
                    </tr>
                    <!-- Nível da vaga -->
                    <tr v-if="vacancy.levelOfInterest != undefined">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Nível da vaga:
                      </th>
                      <td>
                        {{ vacancy.levelOfInterest[vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].relationships.levelOfInterest.data.id].attributes.name }}
                      </td>
                    </tr>
                    <!-- Tipo de contrato -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.contractingRegime != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Seu contrato será:
                      </th>
                      <td>
                        <template v-if="!_.isObject(vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.contractingRegime)">
                          {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.contractingRegime }}
                        </template>
                        <template v-else>
                          Não informado
                        </template>
                      </td>
                    </tr>
                    <!-- PCD -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.exclusivePcd != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Exclusiva PCD:
                      </th>
                      <td>{{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.exclusivePcd ? 'Sim':'Não' }}</td>
                    </tr>
                    <!-- CNH -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.cnh != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        CNH:
                      </th>
                      <td>{{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.cnh }}</td>
                    </tr>
                    <!-- Onde você vai trabalhar -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.location != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Onde você vai trabalhar:
                      </th>
                      <td>{{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.location }}</td>
                    </tr>
                    <!-- Seus horários -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.workingJourney != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Seus horários:
                      </th>
                      <td v-html="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.workingJourney" />
                    </tr>
                    <!-- Benefícios -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.benefitsVerbose != 0">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Benefícios:
                      </th>
                      <td>
                        <p
                          v-for="(benefits, index) in vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.benefitsVerbose"
                          :key="index"
                          class="m-0"
                        >
                          {{ benefits }};
                        </p>
                      </td>
                    </tr>
                    <!-- Salário -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.salary != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.contractingRegime === 'Estagiário' ? 'Bolsa auxílio:' : 'Salário:' }}
                      </th>
                      <td>{{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.salary }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Request and qualification -->
            <div class="card my-5">
              <div
                class="card-header"
                :style="{'background-color': `${getSecondaryColor} !important`}"
              >
                Requisitos e qualificações:
              </div>
              <div class="card-body">
                <table
                  v-if="hasInfoVacancy('company')"
                  class="table table-borderless"
                >
                  <tbody>
                    <!-- Nível de escolaridade -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.educationalLevel != null">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Nível de escolaridade:
                      </th>
                      <td>
                        {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.educationalLevel }} /
                        {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.educationalLevelStatus }}
                      </td>
                    </tr>
                    <!-- Área de formação -->
                    <tr v-if="!_.isEmpty(vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.coursesText)">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Cursos de:
                      </th>
                      <td>
                        {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.coursesText }}
                      </td>
                    </tr>
                    <!-- Descrição da experiência -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.desiredExperiences != null && vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.desiredExperiences.length">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Descrição da experiência:
                      </th>
                      <td v-html="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.desiredExperiences" />
                    </tr>
                    <!-- Cursos -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.complementaryCourses != null && vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.complementaryCourses.length">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Cursos:
                      </th>
                      <td>
                        <p
                          v-for="(course, index) in vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.complementaryCourses"
                          :key="index"
                          class="m-0"
                        >
                          {{ course }};
                        </p>
                      </td>
                    </tr>
                    <!-- Habilidades tecnológicas -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.techSkills">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Conhecimentos em informática:
                      </th>
                      <td>
                        <ul class="tag-list p-0">
                          <li
                            v-for="(skill, index) in vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.techSkills"
                            :key="index"
                            class="m-0 mb-1 mx-1 py-0 px-4"
                            :style="{'background-color': `${getSecondaryColor} !important`}"
                          >
                            {{ skill }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <!-- Mobilidade -->
                    <tr
                      v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.availableForTravel == true ||
                      vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.remoto == true ||
                      vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.hibrida == true ||
                      vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.presencial == true ||
                      vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.availableForChange == true"
                    >
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Mobilidade:
                      </th>
                      <td>
                        <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.availableForTravel == true">
                          Viajar a trabalho,
                        </span>
                        <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.remoto == true">
                          Trabalhar 100% remoto,
                        </span>
                        <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.hibrida == true">
                          Trabalhar no modelo híbrido (home-office/presencial),
                        </span>
                        <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.presencial == true">
                          Trabalhar presencialmente,
                        </span>
                        <span v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.availableForChange == true">
                          Mudança
                        </span>
                      </td>
                    </tr>
                    <!-- Idioma -->
                    <tr v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.languagesVerbose != 0">
                      <th
                        class="font-weight-bold text-right w-25"
                        scope="row"
                        :style="{'color': `${getSecondaryColor} !important`}"
                      >
                        Idioma:
                      </th>
                      <td>
                        <p
                          v-for="(language, index) in vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.languagesVerbose"
                          :key="index"
                          class="m-0"
                        >
                          {{ language }};
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main><!-- /.main-content -->

      <apply-bar />
    </div>
  </layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Layout from './shared/layout.vue';
import ApplyBar from '../components/apply-bar.vue';
import mixins from '../mixins/mixins';

export default {
  name: 'ShowVacancy',
  components: {
    Layout,
    ApplyBar,
  },
  mixins: [mixins],
  props: {
    currentUserProp: {
      type: Object,
      required: true,
    },
    currentUserTypeProp: {
      type: String,
      required: true,
    },
    scopedCompanyProp: {
      type: Object,
      required: true,
    },
    scopedCompanyPageProp: {
      type: Object,
      required: true,
    },
    scopedCompanySubdomainProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actualVacancy: {},
      currentdomain: '',
      separate: window.location.host.split('.'),
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
    ]),
    ...mapState('VacancyStore', [
      'vacancy',
      'vacLoading',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
      'getHeaderImage',
      'getPrimaryColor',
      'getSecondaryColor',
    ]),
  },
  async mounted() {
    const currentUser = { ...this.currentUserProp };
    const currentUserType = this.currentUserTypeProp;
    const scopedCompany = { ...this.scopedCompanyProp };
    const scopedCompanyPage = { ...this.scopedCompanyPageProp };
    const scopedCompanySubdomain = { ...this.scopedCompanySubdomainProp };

    await this.$store.commit('UserStore/SET_CURRENT_USER', currentUser);
    await this.$store.commit('UserStore/SET_CURRENT_USER_TYPE', currentUserType);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY', scopedCompany);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY_PAGE', scopedCompanyPage);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY_SUBDOMAIN', scopedCompanySubdomain);
    await this.$store.dispatch('VacancyStore/loadVacancy');

    this.separate.shift();
    this.currentdomain = this.separate.join('.');
  },
  methods: {
    hasApplied(vac) {
      return vac.meta.candidature;
    },
    hasInfoVacancy(info) {
      return this.vacancy[info] !== undefined;
    },
    setVacancyOwner(vac) {
      let ownerName = '';
      let manageOther = vac.company[vac.vacancy[JSON.parse(Object.keys(vac.vacancy))].relationships.company.data.id].attributes.manageOther;
      let promoteCompany = vac.vacancy[JSON.parse(Object.keys(vac.vacancy))].attributes.promoteCompany === true;

      if (manageOther) {
        if (promoteCompany) {
          ownerName = vac.customer[vac.vacancy[JSON.parse(Object.keys(vac.vacancy))].relationships.customer.data.id].attributes.tradingName;
        } else {
          ownerName = vac.company[vac.vacancy[JSON.parse(Object.keys(vac.vacancy))].relationships.company.data.id].attributes.name;
        }
      } else {
        if (promoteCompany) {
          ownerName = vac.company[vac.vacancy[JSON.parse(Object.keys(vac.vacancy))].relationships.company.data.id].attributes.name;
        } else {
          ownerName = 'Empresa confidencial';
        }
      }
      return ownerName;
    },
    headerClasses() {
      // CETEFE RH 3820
      if (this.currentScopedCompany.id === 3820) {
        return 'header text-white py-2 cetefe-header';
      }

      return 'header text-white py-2';
    },

    infoClasses() {
      // CETEFE RH 3820
      if (this.currentScopedCompany.id === 3820) {
        return 'w-100 p-5 cetefe-global-info-vacancy';
      }

      return 'w-100 p-5';
    },
  },
};
</script>

<style lang="scss" scoped>
  @use '../assets/stylesheet/variables.scss' as *;
  .card-body.card-description {
    ::v-deep {
      p {
        margin-bottom: 0 !important;
      }
    }
  }
  #show-vacancy{
    .cetefe-header {
      height: 720px;
      background-size: 100% 720px;
      background-position: 0 0;

      @media screen and (max-width: 576px) {
        height: 425px;
        background-size: 100% auto;
      }
    }

    header.header {
      #global-info-vacancy {
        background-color: #fff;
        position: absolute;
        bottom: -24%;
        box-shadow: 0px 1px 19px rgba(0, 0, 0, 0.17);
      }

      #global-info-vacancy.cetefe-global-info-vacancy {
        background-color: #fff;
        position: absolute;
        bottom: -14%;
        box-shadow: 0px 1px 19px rgba(0, 0, 0, 0.17);
      }
    }

    #about-vacancy {
      .card {
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.09019607843137255);

        .card-header {
          color: #fff;
          font-size: 1.02rem;
          font-weight: bold;
        }

        table.table {
          border: 0;
        }
      }

      ul.tag-list {
        list-style: none;

        li {
          display: inline-flex;
          background-color: $abler_primary;
          color: #fff;
          border-radius: 50px;
        }
      }
    }

    .table.thead.th {
      line-height: 1.1rem;
    }

    #confirmation-apply-for {
      background-color: #fff;
      border-top: solid $abler_primary;
    }
  }
</style>
